import { render, staticRenderFns } from "./TalentsModal.vue?vue&type=template&id=27d5e8be&scoped=true&"
import script from "./TalentsModal.vue?vue&type=script&lang=js&"
export * from "./TalentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5e8be",
  null
  
)

export default component.exports